/**
 * Treat — variant-specific product copy.
 *
 * On every variant change (PUB_SUB_EVENTS.variantChange from product-info.js):
 * - copies the variant note (#VariantNote-<section>) from the re-rendered section HTML that
 *   product-info.js already fetched, so the note under the description follows the selection;
 * - in any [data-treat-variant-content] group (collapsible rows with a per-variant metafield),
 *   shows the selected variant's content, or the product's default when it has none.
 * Loaded by the main product and collapsible sections; safe to load twice.
 */
if (!window.treatVariantContent) {
  window.treatVariantContent = true;

  const showVariant = (variantId) => {
    const id = String(variantId);
    document.querySelectorAll('[data-treat-variant-content]').forEach((group) => {
      let matched = false;
      group.querySelectorAll('[data-variant-id]').forEach((item) => {
        const isMatch = item.dataset.variantId === id;
        item.hidden = !isMatch;
        if (isMatch) matched = true;
      });
      const fallback = group.querySelector('[data-variant-default]');
      if (fallback) fallback.hidden = matched;
    });
  };

  const start = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.variant) return;
      const note = document.getElementById(`VariantNote-${data.sectionId}`);
      const source = data.html && data.html.getElementById(`VariantNote-${data.sectionId}`);
      if (note && source) note.innerHTML = source.innerHTML;
      showVariant(data.variant.id);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}
